<template>
  <div class="picmanger">
    <div class="header">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>平台运维</el-breadcrumb-item>
          <el-breadcrumb-item>回调管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>回调管理</h4>
        <p v-if="!isRecord">
          <span @click="addToken">+新增回调</span>
          <span @click="callBackRecord({id:0})" style="margin-left:20px;">浏览手动回调日志</span>
        </p>
        <p v-else>
          <el-button @click="isRecord = false" plain>返 回</el-button>
        </p>
      </div>

      <div class="tablebg" v-loading="isRefresh">
        <div style="width: 100%; margin: 0 auto">
          <callbacktable
            v-if="!isRecord"
            :tableData="callbackList"
            @closeClick="closeClick"
            @openClick="openClick"
            @changeClick="changeClick"
            @callBackRecord="callBackRecord"
            @testClick="testClick"
          ></callbacktable>

          <callbackrecordtable
            v-if="isRecord"
            :tableData="callbackRecordList"
          ></callbackrecordtable>
        </div>

        <div class="pagination" v-if="!isRecord">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>

        <div class="pagination" v-if="isRecord">
          <el-pagination
            @size-change="handleSizeChangeRecord"
            @current-change="handleCurrentChangeRecord"
            :current-page.sync="recordCurrentPage"
            :page-size="recordPageSize"
            layout="prev, pager, next"
            :total="recordTotal"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="26%"
      :before-close="handleCloseAdd"
    >
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{dialogTitle}}</div>
      </div>
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="触发动作" prop="actionName">
            <el-select
              clearable
              v-model="ruleForm.actionName"
              placeholder="请选择一个动作"
              style="width: 100%"
            >
              <el-option
                v-for="item in actionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="width: 100%"
                v-html="'<span style=color:#303030;>'+item.label+'</span>'"
              ></el-option>
            </el-select>
            <p style="line-height: 18px; margin-top: 16px">
              系统会在触发动作后，将相关数据回调传输至指定目标。
            </p>
          </el-form-item>

          <el-form-item label="回调目标" prop="target">
            <el-input
              :rows="6"
              type="textarea"
              placeholder="请输入一个本系统可以访问的URL，长度不超过1000个字符"
              v-model="ruleForm.target"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd">关 闭</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="beSure('ruleForm')"
          >提 交</el-button
        >
        <el-button v-else :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" disabled>提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { callbacktable, callbackrecordtable } from "@/components/index";

import {
  deleteCallback,
  addCallback,
  addCallbackLog,
  getCallback,
  getCallbackLog,
  listCallback,
  listCallbackLog,
  updateCallback,
  getCallbackActionTemplate
} from "@/api/callback";
import { formatConversion } from "@/plugins/getdate";
export default {
  components: {
    callbacktable: callbacktable,
    callbackrecordtable: callbackrecordtable,
  },
  data() {
    return {
      //是否显示回调记录
      isRecord: false,

      dialogVisibleAdd: false,
      isClick: false,
      token: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,

      recordTotal: 0,
      recordCurrentPage: 1,
      recordPageSize: 10,
      callbackList: [],
      callbackRecordList: [],
      callbackId: "",
      timeInt: "",
      isRefresh: false,

      isChange: false,
      dialogTitle: "新增回调",
      actionList: [],
      ruleForm: {
        actionName: "",
        target: "",
        status: 0,
        createUid:localStorage.getItem('createUid')
      },
      rules: {
        actionName: [
          { required: true, message: "请选择触发动作", trigger: "change" },
        ],
        target: [
          { required: true, message: "请填写回调目标", trigger: "blur" },
          { min: 0, max: 1000, message: '长度在 0 到 1000 个字符', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (
                /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(value) ==
                false
              ) {
                callback(new Error("请输入正确的Url"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //查看手动日志

    //新增令牌
    addToken() {
      this.dialogTitle = '新增回调'

      this.dialogVisibleAdd = true;
      this.$refs["ruleForm"].resetFields();
    },
    handleCloseAdd() {
      this.isClick = false;
      this.$refs["ruleForm"].resetFields();
      this.ruleForm = {
        actionName: "",
        target: "",
        status: 0,
        createUid:localStorage.getItem('createUid')
      }
      this.dialogTitle = "新增回调";
      this.dialogVisibleAdd = false;
      
    },

    beSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isClick = true;
          setTimeout(() => {
            this.isClick = false;
          }, 2000);

          if (this.dialogTitle == "修改回调") {
            this.updateCallbackAsync(this.ruleForm);
          } else if (this.dialogTitle == "新增回调") {
            // console.log(this.ruleForm);
            this.addCallbackAsync(this.ruleForm);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //修改
    changeClick(row) {
      this.getCallbackAsync(row.id)
      setTimeout(() => {
        this.dialogTitle = '修改回调'
        this.dialogVisibleAdd = true
      }, 400);
    },

    //测试
    testClick() {},

    //回调记录
    callBackRecord(row) {
      this.callbackId = row.id;
      // console.log(row);
      this.handleCurrentChangeRecord(1);
      this.isRecord = true;
    },

    //停用
    closeClick(row) {
      this.$confirm("确定停用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        let data ={
          status:0,
          id:row.id,
          createAt:row.createAt,
          createUid:row.createUid,
          actionName:row.actionName !== '暂无' ? row.actionName : '',
          target:row.target !== '暂无' ? row.target : '',
        }
        this.updateCallbackAsync(data);
      });
    },
    //启动
    openClick(row) {
      this.$confirm("确定启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        let data ={
          status:1,
          id:row.id,
          createAt:row.createAt,
          createUid:row.createUid,
          actionName:row.actionName !== '暂无' ? row.actionName : '',
          target:row.target !== '暂无' ? row.target : '',
        }
        this.updateCallbackAsync(data);
      });
    },
    //分页事件
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let data = { page: this.currentPage - 1, pageSize: this.pageSize };
      // console.log(data)
      this.listCallbackAsync(data);
    },

    //分页事件
    handleSizeChangeRecord(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChangeRecord(val) {
      this.currentPage = val;
      let data = {
        callbackId: this.callbackId,
        page: this.currentPage - 1,
        pageSize: this.pageSize,
      };
      // console.log(data)
      this.listCallbackLogAsync(data);
    },

    //刷新表格
    refresh() {
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    //获取回调列表
    async getCallbackActionTemplateAsync() {
      let { status, data, message, errors } = await getCallbackActionTemplate();
      if (status) {
        this.actionList = []
        for (let i = 0; i < data.length; i++) {
          this.actionList.push({
            label:data[i],
            value:data[i]
          })
          
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //更改
    async updateCallbackAsync(val) {
      let { status, data, message, errors } = await updateCallback(val);
      if (status) {
        this.$message.success(message);
        this.handleCurrentChange(this.currentPage);
        this.handleCloseAdd();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取
    async getCallbackAsync(val) {
      let { status, data, message, errors } = await getCallback(val);
      if (status) {
        this.ruleForm = data;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建
    async addCallbackAsync(val) {
      let { status, data, message, errors } = await addCallback(val);
      if (status) {
        this.$message.success(message);
        this.handleCurrentChange(1);
        this.handleCloseAdd();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取回调日志列表
    async listCallbackLogAsync(val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await listCallbackLog(
        val
      );
      if (status) {
        for (let i = 0; i < data.length; i++) {
          data[i].createMyAt = formatConversion(data[i].createAt.toString());
        }

        this.callbackRecordList = data;
        this.total = pagination.total;
        this.isRefresh = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    },

    //获取回调记录列表
    async listCallbackAsync(val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await listCallback(
        val
      );
      if (status) {

        for (let i = 0; i < data.length; i++) {
          data[i].bindName = data[i].createUserInfo.name;
          data[i].bindId = data[i].createUserInfo.id;
          data[i].createMyAt = formatConversion(data[i].createAt.toString());

          if (!data[i].actionName) {
            data[i].actionName = "暂无";
          }
          if (!data[i].target) {
            data[i].target = "暂无";
          }
        }

        this.callbackList = data;
        this.total = pagination.total;
        this.isRefresh = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    },
  },
  created() {
    this.getCallbackActionTemplateAsync()

    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy() {
    // 组件销毁前调用
    clearTimeout(this.timeInt);
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./callbackmanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
